<script setup lang="ts">

</script>

<template>
  <header class="admin-header login-header">
    <div class="container-fluids">
      <div class="header-top">
        <div class="logo-box">
          <img src="~/assets/img/pc/admin/login-logo.svg" alt="로고" />
        </div>
        <div class="header-login-info-box">
          <span class="text-span">웹사이트 운영을 위한 관리자 모드입니다.</span>
          <a-button href="/">사이트보기</a-button>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">

</style>